/** Profile URL for a stored handle (leading @ is stripped). */
export function instagramProfileUrlFromHandle(handle: string): string | null {
  const user = handle.trim().replace(/^@+/, "");
  if (!user) return null;
  return `https://www.instagram.com/${encodeURIComponent(user)}/`;
}
